
















































import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import staticIcons from "@/utils/static-icons";
import { parseTime } from "@/utils/filters";
import FileListItem from "@/components/FileListItem.vue";
import Loading from "@/components/Loading.vue";

export default Vue.extend({
  name: "file-list-dialog",
  components: {
    FileListItem,
    Loading,
  },
  filters: {
    parseTime(time: string) {
      return parseTime(time, "{y}-{m}-{d} {h}:{i}");
    },
    displayIcon(info: any) {
      return info.thumbnail_link || info.icon_link || staticIcons.other;
    },
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    index: Number,
    selected: Array,
    visible: Boolean,
  },
  data() {
    return {
      fileSelected: [],
      isLoading: false,
      checkAll: false,
    };
  },
  computed: {
    ...mapState("drive", [
      "all",
      "home",
      "spaceMsg",
      "folders",
      "folderNodes",
      "allTaskStatus",
      "uploadList",
      "parentPaths",
      "hasMore",
      "parentId",
      "pageToken",
      "filterTypes",
      "tasks",
      "curFilter",
      "selFileIds",
      "selFileIdsIsAll",
    ]),
    list() {
      return this.home.list || [];
    },
    SYSTEM_FOLDER_LEN() {
      return Object.values(this.all).filter(
        (i: any) => i.folder_type !== "NORMAL"
      ).length;
    },
  },
  watch: {
    parentPaths(val) {
      const currentFolder = val.slice(-1)[0];
      if (currentFolder) {
        if (currentFolder.id === "0") {
          this.currentFolderId = "";
        } else {
          this.currentFolderId = currentFolder.id;
        }
        const subPathArray = val
          .map((v: any) => {
            if (v.id !== "0" && v.id !== "") {
              return v.title;
            }
          })
          .filter((t: any) => t);
        this.currentFileUrlFolderPath = ["我的云盘", ...subPathArray].join("/");
        this.chosenNodeId = currentFolder.id;
      }
    },
    list() {
      if (this.checkAll) {
        const isSpecial = this.isSystemFolder();
        if (isSpecial) {
          this.fileSelected = [...this.list.slice(this.SYSTEM_FOLDER_LEN)];
        } else {
          this.fileSelected = [...this.list];
        }
      }
    },
  },
  mounted() {
    this.getFiles({ parent_id: this.parentId });
  },
  methods: {
    ...mapMutations({
      addFileItem: "drive/add",
      setFileItem: "drive/set",
      deleteFileItem: "drive/deleteFile",
      setFolderNodes: "drive/setFolderNodes",
      setFolderAll: "drive/setFolderAll",
    }),
    isSystemFolder() {
      const isSpecial = [
        this.curFilter === "done",
        this.parentPaths.length === 1,
        this.parentPaths[0].id === "0",
      ].every((i) => i);
      return isSpecial;
    },
    getFiles(params: any, cb: any) {
      this.isLoading = true;

      this.$store
        .dispatch("drive/getFiles", {
          limit: 20,
          ...params,
        })
        .then((res: any) => {
          this.isLoading = false;
          cb && cb(res);
        })
        .catch((err: any) => {
          this.isLoading = false;
        });
    },
    loadMore(visible: boolean) {
      if (!this.hasMore) return;
      if (visible) {
        return this.getFiles({
          page_token: this.pageToken,
          parent_id: this.parentId,
        });
      }
    },
    handleSelectAll(val: any) {
      const isSpecial = this.isSystemFolder();

      // 全选
      if (val) {
        if (isSpecial) {
          this.fileSelected = [...this.list.slice(this.SYSTEM_FOLDER_LEN)];
        } else {
          this.fileSelected = [...this.list];
        }
        this.checkAll = true;
        return;
      }
      // 取消全选
      this.fileSelected = [];
      this.checkAll = false;
    },
    handleItemSelectClick(val: any) {
      this.checkAll = false;
      if (val.checked) {
        this.fileSelected = [val.info.id];
      } else {
        this.fileSelected = [];
      }
      if (this.parentPaths.length === 1 && this.parentPaths[0].id === "0") {
        this.checkAll = this.fileSelected.length === this.list.length - 2;
      } else {
        this.checkAll = this.fileSelected.length === this.list.length;
      }
    },
    handleSelectChange(val: any) {
      if (val.checked) {
        this.fileSelected = Array.from(
          new Set([...this.fileSelected, val.info.id])
        );
      } else {
        const index = this.fileSelected.findIndex(
          (id: string) => id === val.info.id
        );
        index > -1 && this.fileSelected.splice(index, 1);
      }
      if (
        this.curFilter === "done" &&
        this.parentPaths.length === 1 &&
        this.parentPaths[0].id === "0"
      ) {
        this.checkAll =
          this.fileSelected.length ===
          this.list.length - this.CAN_NOT_SELECT_ITEMS;
        return;
      }
      this.checkAll = this.fileSelected.length === this.list.length;
    },
    handleContentClick({ info }: any) {
      if (info.kind.indexOf("folder") > 0) {
        this.fileSelected = [];
        this.checkAll = false;
        // set breadcrum list
        this.$store.commit("drive/setFolder", {
          id: info.id,
          title: info.name,
        });
        this.getFiles({ parent_id: info.id });
      }
    },
    handleRoutelistChange(routeList: any) {
      if (this.curFilter !== "done") return;
      this.setFolderAll(routeList);
      this.fileSelected = [];
      this.checkAll = false;
      const currentRoute = routeList[routeList.length - 1];
      let id = currentRoute.id;
      if (id === "0") {
        id = "";
      }
      this.getFiles({ parent_id: id, limit: 20 });
    },
    cancel() {
      this.$emit("close");
    },
    confirm() {
      const data: any[] = [];
      for (let item of this.fileSelected) {
        data.push(this.all[item]);
      }
      this.$emit("confirm", data);
    },
  },
});
